
import { Character } from "./cDisplayObjects/Character";
import { cGame } from "./cGame";
import { cSprite } from "./cGameObjects/cSprite";
import { Layout } from "./cGameObjects/modules";
import { cScene } from "./cScene";
import { logging } from "./utils/logging";
import { getStr } from "./utils/simpleLocalisation";


export class actionEvaluation {

  private currentScene: cScene;
  private triggers: any
  private nodes: any;
  public container: Phaser.GameObjects.Container | null;

  
  constructor(sc:cScene, evalData:any){
    this.currentScene = sc;
    this.triggers = {}
    this.nodes = {}
    this.container = null;

    var a,el

    for (a in evalData){
      el =  evalData[a]
      // is it a node?
      if (el.type && el.type === 'customNode'){
        // filter triggers
        if ( String(el.name).substr(0,3) === 'on_'){
          this.triggers[ el.name ] = el.id;
          el.trigger = true
        }

        el.output = {}
        this.nodes[ el.id ] = el;
      }
    }

    for (a in evalData){
      el =  evalData[a]
      // is it a edge?
      if (el.source){        
        if (!this.nodes[ el.source ].output[ el.sourceHandle ]){
          this.nodes[ el.source ].output[ el.sourceHandle ] = []
        }
        this.nodes[ el.source ].output[ el.sourceHandle ].push( el.target )
      }
    }

  }

  protected triggerProcess( outputProp:any, payload:any ){
    if (outputProp && Array.isArray(outputProp)){
      outputProp.map( (id:string)=>this.process(id,payload) ) 
    }
  }

  protected parseValue(v:any, payload:any): string | number{
    if (  String('{[').indexOf( String(v).charAt(0)) !== -1 ){
      return this.parseVars(v,payload);
    }else if (String(v).charAt(0) === '='){
      return String(v).substr(1)
    }else{
      return Number(v)
    }
  }

  protected parseVariableString(v:string, payload:any){
    var res = v;
    const regex_curl = /\{(.*?)\}/gm;
    const regex_sq = /\[(.*?)\]/gm;
    var m:any

    while ((m = regex_curl.exec(v)) !== null) {
      if (m.index === regex_curl.lastIndex) regex_curl.lastIndex++;    
      // eslint-disable-next-line  
      m.forEach((match:string, groupIndex:number) => {
        if (groupIndex === 1 && payload[match]){
          res.replaceAll(`{${match}}`,payload[match])
          //console.log(`Found match, group ${groupIndex}: ${match}`);
        }
      });
    }

    while ((m = regex_sq.exec(v)) !== null) {
      if (m.index === regex_sq.lastIndex) regex_sq.lastIndex++;      
      // eslint-disable-next-line
      m.forEach((match:string, groupIndex:number) => {
        if (groupIndex === 1){
          var r = cGame.current.state.get(match,null)
          if (r !== null) res = res.replaceAll(`[${match}]`,r)
          //console.log(`Found match, group ${groupIndex}: ${match}`,r);
        }
      });
    }
    return res
  }


  protected parseVars(v:any,payload:any){
    if (typeof v === 'number' || typeof v === 'undefined') return v;
    if (v.charAt(0) === '{'){
      if (this.currentScene.debugMode){
        return v;
      }
      return payload[ String(v).replace('{','').replace('}','') ];
    }else if (v.charAt(0) === '['){
      let sta = this.currentScene.getState();
      return sta[ String(v).replace('[','').replace(']','') ];
    }else if (v.charAt(0) === '<'){
      let sta = String(v).replace('<','').replace('>','')
      return cGame.current.state.get(sta);
    }else if (v.charAt(0) === '$'){
      return getStr(String(v).replace('$',''))
    }else{
      return v 
    }
  }


  protected compare(sign:string, a:any,b:any): boolean{
    switch (sign){
      case '=': 
      case '==': 
        return String(a)===String(b);
      case '>': 
        return a>b
      case '<': 
        return a<b
      case '!=': 
        return String(a) !== String(b)
      case 'in':
        var bTrim = String(b).replace('[','').replace(']','').split(',')
        return bTrim.indexOf(String(a)) !== -1
      case 'EMPTY':
        return String(b) === '' || String(b) === 'undefined' || String(b) === '0'
      default: 
        return false
    }
  }
  
  protected parseTweenPros( data:string ){
    var tweenOptions:any = {}
    data.split('\n').map( (line:string)=>{
      const g = line.split('=');
      const p = String(g[0]).trim();
      var value = String(g[1]).trim();

      if (isNaN(Number(value))){
        value = Layout.parseOfsAxis(value, p==='x' ? 'x' : 'y' ) as any
      }
      (tweenOptions as any)[p as any] = Number(value);
      return null
    })
    return tweenOptions;
  }

  protected setupTween(el:any, cb:Function ){
    var tweenOptions = this.parseTweenPros( el.props.props || '' );
    try {
      var opt = JSON.parse( el.props.options );
      tweenOptions = {...opt,...tweenOptions}
    }catch (e){
    }
    tweenOptions.targets = this.getGameObject( el.props.target );
    tweenOptions.ease = el.props.easing || 'Quad.easeInOut'
    tweenOptions.duration = Number(el.props.speed);
    tweenOptions.onComplete = ()=>{
      cb();
    }  
    if (this.currentScene.debugMode){
      cb()
    }else{
      this.currentScene.tweens.add(tweenOptions)
    }    
  }

  protected JSON(v:string){
    try{
      return JSON.parse(v)
    }catch (e){
      console.warn('ERROR parsing JSON')
      return {};
    }
  }


  protected getGameObject( name: string){
    if (this.container){
      return this.container.getByName(name)
    }else{
      return this.currentScene.getByName(name)
    }
  }


  public process( nodeid: string, payload:any, nodeData?:any ){
    var el:any = this.nodes[nodeid] || nodeData;
    var actionType = el.trigger ? 'trigger' : el.name;
    var cObject

    //console.log('ACTION::',actionType, el)
    switch (actionType){

      // triggers
      case 'trigger':
        let pl = {...payload}
        if (el.props && el.props.options){
          try {
            let d = JSON.parse(el.props.options)
            pl = {...pl,...d}
          }catch(e){
            console.error('trigger json error')
          }
        }
        this.triggerProcess( el.output.a, pl )
        break;

      case 'triggerevent':
        this.currentScene.triggerSceneEvent(el.props.event,{});
        break;

      case 'goto':
        var goto_props = {...el.props}
        if (!goto_props.target && goto_props.options){
          goto_props.target = this.parseVars(goto_props.options, payload);
          //goto_props.options = null
        }
        this.currentScene.command('goto',goto_props)
        break;

      case 'command':
        var props = {...el.props};
        props.payload = payload
        if (typeof props.options == 'string'){
          props.options = this.parseVars(props.options, payload)
        }
        this.currentScene.command('custome',props, (newPlayload:any)=>{
          this.triggerProcess(el.output.a, newPlayload );
        });
        break;


      case 'crossing':
        this.triggerProcess(el.output.b, payload);
        break;


      case 'bugsnag':
        var bug = (window as any).Bugsnag;
        if (bug){
          bug.notify(new Error( el.props.value ))
        }      
        this.triggerProcess(el.output.b, payload);
        break;


      case 'remove':
        let el_rem
        if (el.props.target){
          var tg:any = this.getGameObject( el.props.target );
          el_rem = tg.getByName( el.props.name )
        }else{
          el_rem = this.getGameObject( el.props.name );
        }
        if (el_rem){
          (el_rem as cSprite).destroy();
          this.triggerProcess(el.output.a, payload);
        }
        break;


      case 'overlay': 
      let opt:any = {}
        try {
          opt = JSON.parse(el.props.options)
          for (var a in opt){
            opt[a] = this.parseVars(opt[a],payload);
          }
        }catch (e){
          opt.options = el.props.options;
          //console.error('OVERLAY OPTIONS NOT JSON')
        }
        var overlay_opt = {...payload,...opt}
        cGame.current.setOverlay(el.props.target, overlay_opt, (res:any)=>{
          if (res) payload = {...payload,...res}
          this.triggerProcess(el.output.b, payload);
        });
        break;


      case 'tween':
        if (!el || !el.props) return
        this.setupTween(el,()=>{
          this.triggerProcess(el.output.b, payload);
        })
        break;


      case 'tweenfromto': 
        if (!el || !el.props) return
        var fromProps = this.parseTweenPros(el.props.props_from);
        var obj:any = this.getGameObject( el.props.target )
        if (!this.currentScene.debugMode){
          Object.keys(fromProps).forEach( k=>{
            (obj as any)[k]  = fromProps[k]          
          });
        }
        this.setupTween(el,()=>{
          this.triggerProcess(el.output.b, payload);
        })      
        break;


      // evaluations
      case 'eval_property':        
        if (el && el.props){
          cObject = this.getGameObject( el.props.target )
          if (cObject){
            var evalStr = el.props.eval
            // eslint-disable-next-line no-eval
            var evalresult = eval('cObject.' + evalStr);
            console.log('EVAL_PROP', cObject, el.props.eval, evalresult, cObject.visible)
            if (evalresult === true){
              this.triggerProcess(el.output.true, payload);
            }else{
              this.triggerProcess(el.output.false, payload);
            }
          }else{
            console.warn('eval_prop')
          }
        }
        break;


      case 'charwalk':
        if (el && el.props){
          cObject = this.getGameObject( el.props.target )
          if (cObject && cObject instanceof Character){
            (cObject as Character).walkinout(el.props.dir,el.props.delay, el.props.options,()=>{
              this.triggerProcess(el.output.a, payload);
            });
          }
        }
        break

        case 'eval_state':
        let [s_var, s_sign, s_value] = String(el.props.eval).split(' ');
        var s_prop =  this.currentScene.getState(s_var);
        s_value = this.parseVars(s_value,payload);

        this.triggerProcess( this.compare(s_sign, s_value, s_prop ) ? el.output.true: el.output.false, payload);
        break;

      case 'eval_global':
        let [evalVar, evalSign, evalValue] = String(el.props.eval).split(' ');
        var evalProp = cGame.current.state.get(evalVar,0)
        this.triggerProcess( this.compare(evalSign, evalValue, evalProp ) ? el.output.true: el.output.false, payload);
        //cGame.current.state
        break;


      case 'eval_global_in_array':
        let inVar  =  cGame.current.state.get(el.props.var,0);
        let inArray:string[] = el.props.array.split('\n');

        console.log('var',inVar,inArray,inArray.indexOf(inVar))
        this.triggerProcess( inArray.indexOf(inVar) !== -1 ? el.output.true: el.output.false, payload);
        break;  

      case 'switch_global':
        let evalModule:string   = el.props.module ? String(el.props.module)+'::' : ''
        var g_evalProp = cGame.current.state.get(evalModule+el.props.eval,0)
        var res = ''
        Object.keys(el.props).forEach( (k)=>{
          if (String(k).indexOf('switch')!==0) return
          if (el.props[k] != '' && el.props[k] == g_evalProp) res = k.replace('switch_','');
        })
        if (res===''){
          this.triggerProcess(el.output['default'], payload);
        }else{
          this.triggerProcess(el.output[res], payload);
        }
        break;


      case 'eval_payload':
        if (!el || !el.props || !el.props.eval) {
          logging.error('ERROR - Payload prop not defined',el);
          return;
        }
        let [p_var, p_sign, p_value] = String(el.props.eval).split(' ');
        this.triggerProcess( this.compare( p_sign, payload[p_var]  , p_value ) ? el.output.true: el.output.false, payload);
        break;

        case 'switch_payload':
          let evalPayload:string   = el.props ? el.props.eval : '';
          let evalPayloadValue: string = payload[ evalPayload ]
          var p_res = ''
          Object.keys(el.props || {}).forEach( (k)=>{
            if (String(k).indexOf('switch')!==0) return
            if (String(el.props[k]) == String(evalPayloadValue)) p_res = k.replace('switch_','');
          })
          if (p_res===''){
            this.triggerProcess(el.output['default'], payload);
          }else{
            this.triggerProcess(el.output[p_res], payload);
          }
          break;



      case 'eval_debugmode':
        this.triggerProcess( (cGame.debugmode === true) ? el.output.true: el.output.false, payload);
        break;

      case 'sndaction':        
        if (this.currentScene.debugMode) { this.triggerProcess(el.output.a, payload); return }        
        if (!el.props || !el.props.name) return
        var ref = this.currentScene.soundData[ el.props.name ];
        if (!ref){          
          if (!el.props.key){
            console.warn('Sound Could not be created - no key')
            return;
          }
          ref = this.currentScene.soundData[ el.props.name ] = this.currentScene.sound.add(el.props.key)
        }
        var $this = this;
        if (ref){
          switch (el.props.control){
            case 'play': 
              var sp:string = el.props.spritename;
              var d:any = this.JSON(el.props.config);
              ref.play(sp,d);
              break;
            case 'pause': ref.pause(); break;
            case 'resume': ref.resume(); break;
            case 'stop': ref.stop(); break;            
          }

          if (el.output.play){
            ref.once('complete',()=>{
              $this.triggerProcess(el.output.play, payload);
            })
          }

          if (el.props.volume !== '' && el.props.volume !== undefined){
            var duration = Number(el.props.duration)
            var vol:any
            if ( String(el.props.volume).indexOf(':') !== -1){
              var [vol_s,vol_m]:any = el.props.volume.split(':');
              ref.volume_x = Number(vol_s) / 100;
              vol          = Number(vol_m) / 100;
            }else{
              vol      = Number(el.props.volume) / 100;
            }

            var steps    = duration / 17;
            var stepVal = (vol-ref.volume_x) / steps;

            if (duration > 0){

              const f = ()=>{
                ref.volume_x += stepVal
                ref.volume = ref.volume_x || 0
                if (steps-- > 0) {
                  window.requestAnimationFrame(f) 
                }else{
                  ref.volume = vol
                  $this.triggerProcess(el.output.fade, payload);
                }
              }

              f();
            }else{
              console.log('SET VOLUME')
              ref.volume = Number(el.props.volume) / 100
            }
          }

        }


        break;

      // actions
      case 'log':
        switch(el.props ? el.props.value : ''){
          case '{payload}': 
            console.log('LOG (payload):', payload); break
          case '{scenestate}':
            let v = this.currentScene.getState()
            console.log('LOG (state):', v); break
          default:
            console.log('LOG :', el.props ? el.props.value : '')
        }      
        this.triggerProcess(el.output.a, payload);
        break;

      // delay
      case 'delay':
        var t = Number(el.props && el.props.value ? el.props.value : 1);
        setTimeout( ()=>{
          this.triggerProcess(el.output.a, {...payload});
        },t)
        break;

      case 'speechbubble':
        let n_el = {...el}
        n_el.props = {...el.props}
        n_el.props._id = el.id 
        n_el.props.value = this.parseVars(n_el.props.value,payload);
        this.currentScene.command('speechbubble',n_el.props, (newPlayload:any)=>{
          this.triggerProcess(el.output.a, {...payload,...newPlayload});
        })
        break;

      case 'speechbubblechoice':
        let nn_el = {...el}
        nn_el.props._id = el.id 
        nn_el.props.value = this.parseVars(nn_el.props.value,payload);       
        this.currentScene.command('speechbubblechoice',el.props, (newPlayload:any)=>{
          this.triggerProcess(el.output[newPlayload], newPlayload);
        })
        break;

      case 'inlinedisplay':
        el.payload = payload;        
        this.currentScene.command('inlinedisplay',el.props, (newPlayload:any)=>{
          this.triggerProcess(el.output.a, newPlayload);
        })
        break;

      case 'hint':
        
        let ne_el = {...el}
        ne_el.props = {...el.props}      
        ne_el.props._id = el.id        
        ne_el.props.value = this.parseVars(ne_el.props.value,payload);

        this.currentScene.command('hint',ne_el.props, (newPlayload:any)=>{
          this.triggerProcess(el.output.a, newPlayload);
        });
        break;

      case 'setstate':
        this.currentScene.setState( el.props.statename, this.parseValue(el.props.statevalue, payload) )
        this.triggerProcess(el.output.a, payload);
        break;

      case 'setglobalstate':
        let newVal:string[] = String(el.props.statevalue).split(' ')
        let module:string   = el.props.statemodule ? String(el.props.statemodule)+'::' : ''

        if (newVal.length === 1){
          cGame.current.state.set( module + el.props.statename, this.parseVars(newVal[0],payload) )
        }else{
          //let curVal = cGame.current.state.get( el.props.statename)
          let nw1 = (newVal[0].charAt(0) === '$') ? cGame.current.state.get( newVal[0].replace('$','') ) : newVal[0];
          let nw2 = (newVal[2].charAt(0) === '$') ? cGame.current.state.get( newVal[2].replace('$','') ) : newVal[2];
          // eslint-disable-next-line no-eval
          let res = eval('' + nw1 + newVal[1] + nw2);

          res = this.parseValue(res,payload)
          
          cGame.current.state.set(module+el.props.statename, res )
        }
        this.triggerProcess(el.output.a, payload);
        break;

      // set property of a object
      case 'setprop':
        if (el.props && el.props.target) {
          var objs = String(el.props.target).split(',')
          objs.forEach( (objName)=>{
            cObject = this.getGameObject( objName )
            if (cObject){
              cObject[ el.props.property ] = this.parseValue(el.props.value, payload)
            }else{
              console.warn('Object not found', el.props.target)
            }
          })
          this.triggerProcess(el.output.a, payload);  
        }
        break;

      case 'spriteanim':
        if (el.props && el.props.target) {
          cObject = this.getGameObject( el.props.target )    
          if (cObject){
            var s:cSprite = cObject as cSprite;
            s.once('animationcomplete',()=>{
              this.triggerProcess(el.output.a, payload);
            })
            s.play(el.props.anim,true)
          }else{
            console.warn('object not found')
          }
        }
        break;

      case 'setmultiprop':
        var jData:any = null;
        try {
          jData = JSON.parse(el.props.property)
        } catch (e){
          console.error('ERRR',e)
        }

        if (jData){
          for (var st in jData){
            var [tar,prop] = st.split(':');
            cObject = this.getGameObject( tar )
            if (cObject){
              cObject[ prop ] = this.parseVars(jData[st],payload) ;
            }else{
              console.warn('Object not found', tar)
            }
          }
        }
        this.triggerProcess(el.output.a, payload);
        break;

      case 'setpayload':
        var payloadData:any = {};
        try {
          payloadData = JSON.parse(el.props.property);        
          Object.keys(payloadData).forEach( (k)=>{
            if (typeof payloadData[k] === 'string'){
              payloadData[k] = this.parseVariableString(payloadData[k], payload)
            }
          });
        } catch (e){
          console.error('ERRR',e)
        }
        this.triggerProcess(el.output.a, {...payload,...payloadData});
        break;

      case 'transformpayload':
        switch (el.props.transform){
          case 'lowercase':
            payload[ el.props.name ] = String( payload[ el.props.name ] ).toLowerCase();
            break;
          case 'uppercase':
            payload[ el.props.name ] = String( payload[ el.props.name ] ).toUpperCase();
            break;
        }
        this.triggerProcess(el.output.a, {...payload});
        break;

      default:
        console.warn('actionType not found', actionType)
    }
  }

  public start( trigger:string, data:any){
    if (this.triggers[ trigger ]){

      this.process(this.triggers[ trigger ],data  )
    }
  }


}